import React from "react";
import { NavLink } from "react-router-dom";
import { Auth } from "redux-server-connection";
import imgLogo from "../../assets/logo.png";
import { bubble as Menu } from 'react-burger-menu'
/* 
 * import GoogleTagManager from "../../components/GoogleTagManager"; 
 * _GoogleTagManager gtmId="UA-144094694-1" /_
 *
 */

import "./styles.css";

/* user.type=3 ==> Data entry */


const Render = (props, context) => {
  const status = props.menuOpen;
  
  const user = Auth.getUser();
  return (
    <div className='topNav'>
      <img src={imgLogo} alt="Superheroes." className="displayBlock imgHeader" />
      <header>
        <div className="container clearfix ">

          <nav
            id="nav"
            className="navMain pRel clearfix desktopMenu"
            aria-label="Men&uacute; principal del sitio."
          >
            <ul className="mainMenu unstyled clearfix">
              <li>
                <NavLink
                  to="/objetivos"
                  className="displayBlock borderBox avenirL white"
                  activeClassName="current"
                >
                  Desafíos
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/ranking"
                  className="displayBlock borderBox avenirL white"
                  activeClassName="current"
                >
                  Ranking
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/productos"
                  className="displayBlock borderBox avenirL white"
                  activeClassName="current"
                >
                  Productos
                </NavLink>
              </li>
              {user && (
                <li className="user">
                  <NavLink
                    to="/dashboard"
                    className="displayBlock borderBox avenirL white"
                    activeClassName="current"
                  >
                    {user.name} {user.surname}
                  </NavLink>
                </li>
              )}
              <li className="salir">
                <NavLink
                  to="/"
                  className="displayBlock borderBox avenirL white"
                  onClick={props.logout}

                >
                  Salir
                </NavLink>
              </li>
            </ul>
          </nav> 

          <Menu right className="mobileMenu" 
                isOpen={status}
                >
            <NavLink
              to="/objetivos"
              className="displayBlock borderBox avenirL white"
              activeClassName="current"
              onClick={() => props.closeMenu()}
            >
              Desafíos
            </NavLink>
            <NavLink
              to="/ranking"
              className="displayBlock borderBox avenirL white"
              activeClassName="current"
              onClick={() => props.closeMenu()}
            >
              Ranking
            </NavLink>

            <NavLink
              to="/productos"
              className="displayBlock borderBox avenirL white"
              activeClassName="current"
              onClick={() => props.closeMenu()}
            >
              Productos
            </NavLink>

            {user && (
              <NavLink
                  to="/dashboard"
                  className="displayBlock borderBox avenirL white"
                  activeClassName="current"
                  onClick={() => props.closeMenu()}
                >
                  {user.name} {user.surname}
              </NavLink>
            )}
            <NavLink
              to="/"
              className="displayBlock borderBox avenirL white"
              onClick={props.logout}
            >
              Salir
            </NavLink>
          </Menu >
        </div>
      </header>
    </div>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/components/Header/Render.js